import { Messages } from '../../gen-src/Localize';
import { ToolbarItem } from '../PublicTypes';

export namespace GroupItems {
  export const edit: ToolbarItem = {
    label: Messages.edit(),
    iconId: 'edit',
    id: 'edit',
    showLabel: true,
    itemType: 'button',
    onClick: () => {},
    region: 'insights',
    testId: 'edit',
  };
  export const data: ToolbarItem = {
    label: Messages.data(),
    iconId: 'data',
    id: 'data',
    showLabel: true,
    itemType: 'button',
    onClick: () => {},
    region: 'insights',
    testId: 'data',
  };
  export const discover: ToolbarItem = {
    label: Messages.discover(),
    iconId: 'discover',
    id: 'discover',
    showLabel: true,
    itemType: 'button',
    onClick: () => {},
    region: 'insights',
    testId: 'discover',
  };
  export const watch: ToolbarItem = {
    label: Messages.watch(),
    description: Messages.watchTooltip(),
    iconId: 'watch',
    id: 'watch',
    showLabel: true,
    itemType: 'button',
    onClick: () => {},
    region: 'watch',
    testId: 'watch',
  };
  export const display: ToolbarItem = {
    label: Messages.display(),
    description: Messages.displayTooltip(),
    iconId: 'display',
    id: 'display',
    itemType: 'button',
    onClick: () => {},
    region: 'collaborate',
    testId: 'display',
  };
  export const download: ToolbarItem = {
    label: Messages.download(),
    description: Messages.downloadTooltip(),
    iconId: 'download',
    id: 'download',
    itemType: 'button',
    onClick: () => {},
    region: 'collaborate',
    testId: 'download',
  };
}
